<h1 mat-dialog-title>Delivery Price Tool</h1>
<div class="flex flex-col justify-start items-stretch" mat-dialog-content>
  <p>Use this to quickly find out the costs of delivery for a given address.</p>
  <app-address-search-field [formControl]="address"></app-address-search-field>
  <app-delivery-estimate
    [destination]="address.value?.place_id"
  ></app-delivery-estimate>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button matDialogClose>Close</button>
</div>
